import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  paper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    textAlign: 'center',
    padding: theme.spacing.unit
  },
  header: {
    margin: theme.spacing.unit*2
  }
})

class Welcome extends React.Component {

  state = {}

  render() {
    const { classes } = this.props
    return (
      <Paper className={classes.paper} elevation={1}>
        <Typography gutterBottom variant='headline' color='secondary' className={classes.header}>
          Welcome
        </Typography>
        <Typography>
          Welcome to the Addresscloud Admin console.  Please select an option from the menu on the
          left to get started.  Our API documentation can be viewed
          at <a href='https://docs.addresscloud.com' target='_docs'>docs.addresscloud.com</a>.
        </Typography>
      </Paper>
    )
  }
}

Welcome.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Welcome)
